import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import SecondLoader from "../SecondLoader";
import AddEmergencyContactSchema from "../../utils/SchemasValidation/AddEmergencyContactSchema";
import ValidateSchema from "../../helpers/ValidateSchema";
import { MdClose } from "react-icons/md";
import FormInput from "../../components/Forms/FormInput";
import PhoneInput from "react-phone-input-2";
import ImageUpload from "../../components/ImageUpload";
import pictureicon from "../../assets/images/function_page_icons/picIcon.svg";
import contacticon from "../../assets/images/function_page_icons/contacticon.svg";
import deleteicon from "../../assets/images/function_page_icons/delete.svg";
import _ from "lodash";
import { validatePhoneWithCountryCode } from "../../utils/functions";
import showToast from "../../helpers/showToast";
import { EMERGENCY_CONTACT_VCF_FILE_URL } from "../../utils/constants/apiUrl";
import { post } from "../../server";
import { loggedInUser } from "../../utils/store";
import { useAtom } from "jotai";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { trackEvent } from "../../utils/mixpanel";
import { useLocation } from "react-router-dom";

const MedicalAddEditModal = ({
  loading,
  data,
  setSelectedData,
  handleSaveShowModal,
  handleCloseModal,
  show,
  publicMode,
}) => {
  const [errors, setErrors] = useState({});
  const [imagePath, setImagePath] = useState("");
  const [medicalID, setMedicalID] = useState({});
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [MedicalEmergencyContacts, setMedicalEmergencyContacts] = useState([]);
  const [showEmergencyContacts, setShowEmergencyContacts] = useState(false);

  useEffect(() => {
    if (publicMode && !data.isNew) {
      setMedicalID(data);

      // setMedicalEmergencyContacts(data.medicalIdEmergencyContacts || []);
    }
  }, [publicMode, data]);
  useEffect(() => {
    if (data?.medicalIdEmergencyContact?.length > 0) {
      setMedicalEmergencyContacts(data.medicalIdEmergencyContact);
      setShowEmergencyContacts(true); // Ensure the emergency contacts section is visible
    }
  }, [data]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    // Restrict weight and height to only numbers
    if (name === "weight" || name === "height") {
      // Allow only digits (and optional decimal if needed)
      const regex = /^[0-9]*\.?[0-9]*$/;

      if (!regex.test(value)) {
        return; // 🚫 don't update state if invalid
      }
    }

    setSelectedData({ ...data, [name]: value });
  };

  const handleDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      // Format the date to YYYY-mm-dd
      const formattedDate = date.toISOString().split("T")[0];
      setSelectedData({ ...data, dob: formattedDate });
    } else {
      // Handle invalid date
      setSelectedData({ ...data, dob: null });
    }
  };

  // handle Validation
  const validateForm = () => {
    let newErrors = ValidateSchema(data, AddEmergencyContactSchema);
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return false;

    // Check if phone number is empty
    if (!data.phone_number) {
      setErrors({ ...errors, phone_number: "Phone number is required" });
      return false;
    }
    if (
      data.phone_number.length > data.country_phone.length ||
      data.phone_number.length === data.country_phone.length
    ) {
      let resultPhone = validatePhoneWithCountryCode(
        data.country_phone,
        data.phone_number
      );
      if (resultPhone) {
        setErrors({
          phone_number: resultPhone,
        });
        return false;
      }
    }
    return true;
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dynamicQRCodeId = searchParams.get("dynamic_qr_code");

  const handleAddUrl = async (e) => {
    //if (!validateForm()) return;

    let newData = _.cloneDeep(data);
    newData.photo = imagePath;
    newData.medicalIdEmergencyContacts = MedicalEmergencyContacts;
    setSelectedData(newData);
    handleSaveShowModal(newData);
  };

  useEffect(() => {
    setImagePath(data?.photo);
  }, [data.photo]);

  const handleVcfFile = async () => {
    // setLoading(true);
    let { status, message, data } = await post(
      EMERGENCY_CONTACT_VCF_FILE_URL + `/${medicalID.uuid}`,
      medicalID,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      const link = document.createElement("a");
      link.download = "temp.vcf";
      link.href = data.url;
      link.click();
    } else {
      showToast(status, message);
    }
    // setLoading(false);
  };

  const handleAddEmergencyContact = () => {
    setMedicalEmergencyContacts([
      ...MedicalEmergencyContacts,
      { person_name: "", relation: "", country_phone: "", phone_number: "" },
    ]);
    setShowEmergencyContacts(true);
  };

  const handleEmergencyContactChange = (index, e) => {
    const { name, value } = e.target;
    const updatedContacts = MedicalEmergencyContacts.map((contact, i) =>
      i === index ? { ...contact, [name]: value } : contact
    );
    setMedicalEmergencyContacts(updatedContacts);
  };

  const handleRemoveEmergencyContact = (index) => {
    const updatedContacts = MedicalEmergencyContacts.filter(
      (_, i) => i !== index
    );
    setMedicalEmergencyContacts(updatedContacts);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          setImagePath("");
          handleCloseModal();
          setErrors({});
          setMedicalID({});
        }}
        className="customModal square-modal medical-modal"
        // size="xl"
      >
        <Modal.Header className="modalHeader d-flex justify-content-between">
          <span className="modalHeading">
            {publicMode ? "View" : data?.id ? "Edit" : "Add "} Medical ID
          </span>
          <div className="modalGradientCircle"></div>
          <MdClose
            onClick={() => {
              setImagePath("");
              handleCloseModal();
              setErrors({});
              setMedicalID({});
            }}
            className="modalCloseBtn"
          />
        </Modal.Header>
        {loading ? (
          <SecondLoader />
        ) : (
          <>
            <Modal.Body>
              <div className="container-fluid p-3">
                <div className="d-flex justify-content-center mb-4">
                  <ImageUpload
                    imageLink
                    imageUrl={data.photo}
                    imageType="medical_id"
                    setPath={setImagePath}
                    width="120px"
                    height="120px"
                    dummyImage={pictureicon}
                  />
                </div>

                <div className="row g-3">
                  <div className="col-md-6">
                    <FormInput
                      type="text"
                      label="First Name"
                      placeholder="Enter first name"
                      name="first_name"
                      value={data.first_name}
                      onChange={handleChange}
                      error={errors?.first_name}
                      readOnly={publicMode}
                    />
                  </div>
                  <div className="col-md-6">
                    <FormInput
                      type="text"
                      label="Last Name"
                      placeholder="Enter last name"
                      name="last_name"
                      value={data.last_name}
                      onChange={handleChange}
                      error={errors?.last_name}
                      readOnly={publicMode}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Date of Birth</label>
                    <DatePicker
                      selected={data.dob ? new Date(data.dob) : null}
                      onChange={handleDateChange}
                      dateFormat="yyyy/MM/dd"
                      className="form-control"
                      placeholderText="yyyy/MM/dd"
                      showYearDropdown
                      isClearable
                      maxDate={new Date()} // allow up to today
                      excludeDates={[new Date()]} // but disable today
                      yearDropdownItemNumber={110}
                      scrollableYearDropdown
                    />
                  </div>

                  <div className="col-md-6">
                    <FormInput
                      type="text"
                      label="Language"
                      placeholder="Enter Language"
                      name="primary_language"
                      value={data.primary_language}
                      onChange={handleChange}
                      error={errors?.primary_language}
                      readOnly={publicMode}
                    />
                  </div>

                  {/* Medical Details */}
                  <div className="col-md-6">
                    <FormInput
                      type="text"
                      label="Blood Type"
                      placeholder="Enter Blood Type"
                      name="blood_type"
                      value={data.blood_type}
                      onChange={handleChange}
                      error={errors?.blood_type}
                      readOnly={publicMode}
                    />
                  </div>
                  <div className="col-md-6">
                    <FormInput
                      type="text"
                      label="Weight"
                      placeholder="Enter Weight"
                      name="weight"
                      value={data.weight}
                      onChange={handleChange}
                      error={errors?.weight}
                      readOnly={publicMode}
                    />
                  </div>
                  <div className="col-md-6">
                    <FormInput
                      type="text"
                      label="Height"
                      placeholder="Enter Height"
                      name="height"
                      value={data.height}
                      onChange={handleChange}
                      error={errors?.height}
                      readOnly={publicMode}
                    />
                  </div>
                  <div className="col-md-6">
                    <FormInput
                      type="text"
                      label="Medical Condition"
                      placeholder="Enter Medical Condition"
                      name="medical_condition"
                      value={data.medical_condition}
                      onChange={handleChange}
                      error={errors?.medical_condition}
                      readOnly={publicMode}
                    />
                  </div>
                  <div className="col-md-12">
                    <FormInput
                      type="text"
                      label="Allergies Reactions"
                      placeholder="Enter Allergies Reactions"
                      name="allergies_reactions"
                      value={data.allergies_reactions}
                      onChange={handleChange}
                      error={errors?.allergies_reactions}
                      readOnly={publicMode}
                    />
                  </div>

                  {/* Textareas */}
                  <div className="col-12">
                    <label className="form-label">Medical Notes</label>
                    <textarea
                      name="medical_notes"
                      readOnly={publicMode}
                      rows="3"
                      value={data.medical_notes}
                      placeholder="Enter Medical Notes"
                      onChange={handleChange}
                      className={`form-control ${
                        errors?.medical_notes ? "is-invalid" : ""
                      }`}
                    />
                    {errors?.medical_notes && (
                      <div className="invalid-feedback d-block">
                        {errors.medical_notes}
                      </div>
                    )}
                  </div>

                  <div className="col-12">
                    <label className="form-label">Medications</label>
                    <textarea
                      name="medications"
                      readOnly={publicMode}
                      rows="3"
                      value={data.medications}
                      placeholder="Enter Medications"
                      onChange={handleChange}
                      className={`form-control ${
                        errors?.medications ? "is-invalid" : ""
                      }`}
                    />
                    {errors?.medications && (
                      <div className="invalid-feedback d-block">
                        {errors.medications}
                      </div>
                    )}
                  </div>

                  {/* Emergency Contacts */}
                  {/* {showEmergencyContacts && (
        <div className="col-12 mt-3">
          <h6 className="mb-2">Emergency Contacts</h6>
          {MedicalEmergencyContacts.map((contact, index) => (
            <div className="row g-3 align-items-end mb-3" key={index}>
              <div className="col-md-4">
                <FormInput
                  type="text"
                  label="Person Name"
                  placeholder="Enter person name"
                  name="person_name"
                  value={contact.person_name}
                  onChange={(e) => handleEmergencyContactChange(index, e)}
                />
              </div>
              <div className="col-md-3">
                <FormInput
                  type="text"
                  label="Relation"
                  placeholder="Enter relation"
                  name="relation"
                  value={contact.relation}
                  onChange={(e) => handleEmergencyContactChange(index, e)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Phone Number</label>
                <PhoneInput
                  country={"us"}
                  enableSearch
                  countryCodeEditable={false}
                  inputClass={
                    errors.phone_number
                      ? "phoneNumberInput errorInput"
                      : "phoneNumberInput"
                  }
                  value={contact.phone_number}
                  onChange={(value, country) => {
                    setMedicalEmergencyContacts((prev) =>
                      prev.map((c, i) =>
                        i === index
                          ? {
                              ...c,
                              phone_number: value,
                              country_phone: country.dialCode,
                            }
                          : c
                      )
                    );
                  }}
                />
              </div>
              <div className="col-md-1 text-end">
                <Button
                  variant="outline-danger"
                  onClick={() => handleRemoveEmergencyContact(index)}
                >
                  <img src={deleteicon} alt="Delete" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )} */}

                  {showEmergencyContacts && (
                    <div className="col-12 mt-3">
                      <h6 className="mb-3">Emergency Contacts</h6>
                      {MedicalEmergencyContacts.map((contact, index) => (
                        <div
                          className="row g-3 align-items-end mb-3"
                          key={index}
                        >
                          <div className="col-12">
                            <FormInput
                              type="text"
                              label="Person Name"
                              placeholder="Enter person name"
                              name="person_name"
                              value={contact.person_name}
                              onChange={(e) =>
                                handleEmergencyContactChange(index, e)
                              }
                            />
                          </div>
                          <div className="col-12">
                            <FormInput
                              type="text"
                              label="Relation"
                              placeholder="Enter relation"
                              name="relation"
                              value={contact.relation}
                              onChange={(e) =>
                                handleEmergencyContactChange(index, e)
                              }
                            />
                          </div>
                          <div className="col-12">
                            <label className="form-label">Phone Number</label>
                            <PhoneInput
                              country={"us"}
                              enableSearch
                              countryCodeEditable={false}
                              inputClass={
                                errors.phone_number
                                  ? "phoneNumberInput errorInput"
                                  : "phoneNumberInput"
                              }
                              value={contact.phone_number}
                              onChange={(value, country) => {
                                setMedicalEmergencyContacts((prev) =>
                                  prev.map((c, i) =>
                                    i === index
                                      ? {
                                          ...c,
                                          phone_number: value,
                                          country_phone: country.dialCode,
                                        }
                                      : c
                                  )
                                );
                              }}
                            />
                          </div>
                          <div className="col-12 col-md-1 text-end">
                            <Button
                              variant="outline-danger"
                              onClick={() =>
                                handleRemoveEmergencyContact(index)
                              }
                            >
                              <img src={deleteicon} alt="Delete" />
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="col-12 text-start">
                    <Button
                      type="button"
                      onClick={handleAddEmergencyContact}
                      className="btn btn-primary mt-2"
                    >
                      Add Emergency Contact
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer
              style={{ justifyContent: publicMode ? "center" : "flex-end" }}
            >
              {publicMode ? (
                <div className="text-center savePhonebookBtnWrapper">
                  <button onClick={handleVcfFile}>
                    <span>
                      <img src={contacticon} alt="" />
                    </span>
                    Save Contact
                  </button>
                </div>
              ) : (
                <div className="btnWrapper">
                  <Button
                    type="button"
                    onClick={() => {
                      setImagePath("");
                      handleCloseModal();
                      setErrors({});
                    }}
                    variant="outline-primary"
                    className="cancelBtn mx-3"
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="primary"
                    type="button"
                    onClick={handleAddUrl}
                    className="saveBtn"
                  >
                    Save
                  </Button>
                </div>
              )}
            </Modal.Footer>
          </>
        )}
      </Modal>
      <style type="text/css">
        {`
          .dobInput{
            color: #333333
          }
        `}
      </style>
    </>
  );
};

export default MedicalAddEditModal;
